import { WelcomeResource } from './WelcomeResource';

export class WelcomeListResource {
    list: WelcomeResource[];
}